<template>
  <div class="content">
    <div class="content_text">
      <div class="subMyShareItem_top">
        <div class="subMyShareItem_top_left">
          <img class="userAvatar" :src="subShareDetail.avatar" alt="">
          <div class="nick">
            <div class="nick_name">{{subShareDetail.nickname}}</div>
            <div class="nick_time">{{subShareDetail.created_at | TimeFilter}}</div>
          </div>
        </div>
        <div class="subMyShareItem_status"></div>
      </div>
      <div class="subMyShareItem_contentText">{{subShareDetail.content}}</div>
      <div class="subMyShare_imgBox" v-if="subShareDetail.images&&subShareDetail.images.length > 0">
        <img class="subMyShare_img" v-for="(url,index) in subShareDetail.images" :key="'img'+index" :src="url" alt=""
          @click="open_app()">
      </div>
      <div class="subMyShare_videoBox" v-if="subShareDetail.video_cover&&subShareDetail.video_cover.length > 0"
        @click="open_app()">
        <img class="subMyShare_videoCover" :src="subShareDetail.video_cover[0]" alt="">
        <img class="subMyShareItem_videoCover_playIcon" src="../../assets/house/playBig.png" alt="">
      </div>
    </div>
    <div class="bar"></div>
    <div class="subMyShare_comments_num">评论{{' '+subShareDetail.comment}}</div>
    <div class="subMyShare_comments_list" v-if="subShareDetail.comment>0">
      <div class="subMyShare_comments_item" v-for="(item,index) in comments_list" :key="'comments'+index">
        <div class="subMyShare_comments_item_top">
          <div class="subMyShare_comments_item_top_left">
            <img class="comments_userAvatar" :src="item.avatar" alt="">
            <div class="comments_nickname">{{item.nickname}}</div>
          </div>
        </div>
        <div class="subMyShare_comments_item_content">{{item.content}}</div>
        <div class="subMyShare_comments_item_time">{{item.created_at | TimeFilter}}</div>
      </div>
    </div>


    <div class="subMyShare_comments_list_none" v-else>
      <img class="subMyShare_comments_list_none_img" src="../../assets/house/noNeeds.png" alt="">
      <div class="noNeeds_txt">暂无评论</div>
    </div>

    <!-- <div class="share" v-if="isWeixin || isQQ" @click="open_mask()">
      <div class="share_btn">去APP查看</div>
    </div> -->
    <div class="share" @click="open_app()">
      <div class="share_btn">去APP查看</div>
    </div>
    <div class="weixin-tip" v-if="maskShow">
      <p>
        <img v-if="!isIOS" src="../../assets/common/live_weixin.png" alt="微信打开" />
        <img v-if="isIOS" src="../../assets/common/live_weixin_ios.png" alt="微信打开" />
      </p>
    </div>
  </div>
</template>

<script>
  import navBar from "./components/navBar";
  export default {
    components: {
      navBar,
    },
    data() {
      return {
        id: '',
        isIOS: false,
        isWeixin: false,
        isQQ: false,
        maskShow: false,
        subShareDetail: {},
        comments_list: [],
      }
    },
    filters: {
      TimeFilter(time) {
        let defaultTime = time
        // ios将时间戳 "-" 转换为 "/" 
        if (time) {
          time = time.replace(/-/g, '/');
        }
        let oldDate = new Date(time)
        let newDate = new Date()
        var dayNum = "";
        var getTime = (newDate.getTime() - oldDate.getTime()) / 1000;

        if (getTime < 60 * 5) {
          dayNum = "刚刚";
          return dayNum
        } else if (getTime >= 60 * 5 && getTime < 60 * 60) {
          dayNum = parseInt(getTime / 60) + "分钟前";
          return dayNum
        } else if (getTime >= 3600 && getTime < 3600 * 24) {
          dayNum = parseInt(getTime / 3600)
          if (dayNum > 1) {
            return defaultTime
          } else {
            return dayNum + "小时前";
          }
        } else {
          return defaultTime
        }
      }
    },
    created() {
      this.id = this.$route.query.id || 3
      this.getSubShareDetail();
      var u = navigator.userAgent;
      this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (u.toLowerCase().indexOf('qq') > -1 && u.toLowerCase().indexOf('mqqbrowser') < 0 && this.isIOS) {
        //qq内置浏览器
        this.isQQ = true;
      }
    },
    methods: {
      getSubShareDetail() {
        this.$api.post('/estate/index/subsidy/sharing/detail', {
          id: this.id,
          page: 1,
          size: 10
        }).then(res => {
          this.subShareDetail = res
          this.comments_list = res.list.data
        })
      },
      open_mask() {
        this.maskShow = true;
      },
      open_app() {
        if (this.isWeixin || this.isQQ) {
          this.maskShow = true;
        } else {
          let baseUrl = process.env.VUE_APP_WEEX_HOST
          this.parmSrc =
            `house/index?house_js=${baseUrl}/subShareDetail.js?id=${this.id}&baseUrl=${baseUrl}`
          this.openApp('', '', this.parmSrc)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .content {
    box-sizing: border-box;
    padding-bottom: 70px;
    font-size: 14px;
    color: #333;
    overflow: auto;
  }

  .content_text {
    padding: 16px 0 0;
  }

  .subMyShareItem_top {
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .subMyShareItem_top_left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .userAvatar {
    width: 40px;
    height: 40px;
    margin-right: 6px;
    border-radius: 100%;
    overflow: hidden;
    position: relative;
  }

  .nick_name {
    font-size: 15px;
    font-weight: 500;
    color: #181B1F;
    line-height: 15px;
    margin-bottom: 6px;
  }

  .nick_time {
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 12px;
  }

  .subMyShareItem_contentText {
    font-size: 15px;
    font-weight: 400;
    color: #181B1F;
    line-height: 23px;
    padding: 8px 0;
    padding-left: 16px;
    margin-bottom: 8px;
  }

  .subMyShare_imgBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .subMyShare_img {
    width: 343px;
    border-radius: 3px;
    margin-bottom: 8px;
  }

  .subMyShare_videoBox {
    width: 343px;
    height: 192px;
    border-radius: 6px;
    position: relative;
    margin-bottom: 16px;
  }

  .subMyShare_videoCover {
    position: absolute;
    top: 0;
    left: 0;
    width: 343px;
    height: 192px;
    border-radius: 6px;
  }

  .subMyShareItem_videoCover_playIcon {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .bar {
    width: 100%;
    height: 7px;
    background-color: #F7F7F7;
  }

  .subMyShare_comments_num {
    padding-top: 17px;
    padding-bottom: 20px;
    padding-left: 16px;
    font-size: 13px;
    font-weight: 500;
    color: #000000;
  }

  .subMyShare_comments_list_none {
    padding-top: 80px;
    padding-bottom: 213px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .subMyShare_comments_list_none_img {
    width: 160px;
    height: 160px;
    margin-bottom: 16px;
  }

  .noNeeds_txt {
    font-size: 14px;
    font-weight: 400;
    color: #969799;
    line-height: 20px;
  }

  .subMyShare_comments_item {
    width: 100%;
    margin-bottom: 64px;
  }

  .subMyShare_comments_item_top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 14px;
    padding-right: 16px;
  }

  .subMyShare_comments_item_top_left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .comments_userAvatar {
    width: 25px;
    height: 25px;
    margin-right: 6px;
    border-radius: 100%;
    overflow: hidden;
    position: relative;
  }

  .comments_nickname {
    font-size: 13px;
    font-weight: 500;
    color: #181B1F;
  }

  .subMyShare_comments_item_content {
    padding-left: 45px;
    padding-right: 16px;
    padding-top: 6px;
    padding-bottom: 16px;
    font-size: 14px;
    color: #181B1F;
    line-height: 20px;
  }

  .subMyShare_comments_item_time {
    padding-left: 45px;
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
  }

  .share {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 98px;
    padding: 8px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
  }

  .share_btn {
    width: 343px;
    height: 48px;
    background: #26C165;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 48px;
    text-align: center;
  }

  .weixin-tip {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .7);

    p {
      padding: 15px 25px;

      img {
        width: 100%;
        display: block;
      }
    }
  }
</style>